import { render } from "./signupCustomForm.vue?vue&type=template&id=52f7ed25&scoped=true"
import script from "./signupCustomForm.vue?vue&type=script&lang=js"
export * from "./signupCustomForm.vue?vue&type=script&lang=js"

import "./signupCustomForm.vue?vue&type=style&index=0&id=52f7ed25&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f7ed25"]])

export default __exports__